import { render, staticRenderFns } from "./courseSorter.vue?vue&type=template&id=cca32188&scoped=true"
import script from "./courseSorter.vue?vue&type=script&lang=js"
export * from "./courseSorter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca32188",
  null
  
)

export default component.exports